export default __webpack_public_path__ + "media/images/images/flags/ok-e5443761f738d4b8fea1599808fa4f4b.png";